import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../shared/GlobalStyles';
import DatePicker from '../../../../shared/_TBComponents/DatePicker';
import DropDown from '../../../force-plate-dashboard/components/presentational/ForcePlateDropDown';
import OverviewChart from './OverviewChart';
import {
  fetchPublicVBTData,
  setSelectedAthlete,
  setSelectedExercise,
} from '../../ducks/vbtDashboardActions';
import Icon from '../../../../shared/_TBComponents/Icon';
import Text from '../../../../shared/_TBComponents/Text';
import ThresholdFilter from '../ThresholdFilter';

const DashboardContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: ${BoxShadow};
  display: flex;
  flex-direction: column;
  height: fit-content;
  margin: 15px 15px 7px 15px;
  padding: 16px;
  position: relative;
`;

const DayOption = styled('button')`
  border: none;
  color: ${(props) => (!props.isActive ? '#9E9E9E' : null)};
  cursor: ${(props) => (props.readOnly ? 'default !important' : 'pointer')};
  font-family: 'Nunito Sans';
  font-size: 16px;
`;

const DaySelector = styled('div')`
  align-self: center;
  display: flex;
  margin-right: 10px;
`;

const DaySpacer = styled('span')`
  color: #9e9e9e;
  font-family: 'Nunito Sans';
  font-size: 25px;
  font-weight: 100;
  margin: 0px 3px;
`;

const MenuOptionsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

const OptionsHeader = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 26px;
`;

const SubtitleContainer = styled('div')`
  display: flex;
`;

const ViewOnlyOverview = ({ token }) => {
  const athletes = useSelector((state) => state.vbtDashboard.data.athletes);
  const dateRange = useSelector((state) => state.vbtDashboard.data.dateRange);
  const exercises = useSelector((state) => state.vbtDashboard.data.exercises);
  const group = useSelector((state) => state.vbtDashboard.data.group);
  const selectedAthlete = useSelector((state) => state.vbtDashboard.data.selectedAthlete);
  const selectedExercise = useSelector((state) => state.vbtDashboard.data.selectedExercise);
  const selectedEndDateOverview = useSelector(
    (state) => state.vbtDashboard.data.selectedEndDateOverview,
  );

  const dispatch = useDispatch();

  const setAthlete = (athlete) => {
    dispatch(setSelectedAthlete(athlete, true));
  };

  const setExercise = (exer) => {
    if (!exer.id) return;
    batch(() => {
      dispatch(setSelectedExercise(true, exer));
      dispatch(fetchPublicVBTData(exer.id, token));
    });
  };

  const emptyFunction = () => undefined;

  return (
    <>
      <DashboardContainer>
        <SubtitleContainer>
          <Icon
            color='#9E9E9E'
            icon='group'
            size='24px'
          />
          <Text
            styledTextProps={{
              fontSize: '19px',
              fontWeight: '700',
              marginLeft: '10px',
            }}
          >
            Group Performance
          </Text>
        </SubtitleContainer>
        <OptionsHeader>
          <MenuOptionsContainer>
            <DropDown
              defaultOption={group || {}}
              disabled
              headerWidthPx={220}
              label='name'
              list={['']}
              placeholder='Select a Group'
              readOnly
              selectItemFunction={emptyFunction}
            />
            <DropDown
              defaultOption={selectedExercise || {}}
              disabled={!group?.id}
              label='name'
              list={exercises}
              headerWidthPx={220}
              placeholder='Select an Exercise'
              selectItemFunction={setExercise}
            />
            <ThresholdFilter isMulti />
          </MenuOptionsContainer>
          <MenuOptionsContainer>
            <DaySelector>
              <DayOption
                isActive={dateRange === 13}
                readOnly
              >
                2W
              </DayOption>
              <DaySpacer> | </DaySpacer>
              <DayOption
                isActive={dateRange === 27}
                readOnly
              >
                4W
              </DayOption>
              <DaySpacer> | </DaySpacer>
              <DayOption
                isActive={dateRange === 55}
                readOnly
              >
                8W
              </DayOption>
            </DaySelector>
            <DatePicker
              disabled
              setStartDate={emptyFunction}
              startDate={selectedEndDateOverview || null}
              styledWrapperProps={{
                alignSelf: 'center',
                customBorder: '1px solid #D8D8D8',
                customHeight: '42px',
              }}
            />
          </MenuOptionsContainer>
        </OptionsHeader>
        {/* Group  Chart */}
        <OverviewChart />
        <SubtitleContainer style={{ marginTop: '20px' }}>
          <Icon
            color='#9E9E9E'
            icon='user'
            size='20px'
          />
          <Text
            styledTextProps={{
              fontSize: '19px',
              fontWeight: '700',
              marginLeft: '10px',
            }}
          >
            Athlete Performance
          </Text>
        </SubtitleContainer>
        <MenuOptionsContainer style={{ marginBottom: '26px' }}>
          <DropDown
            defaultOption={selectedAthlete || {}}
            disabled={!group?.id}
            label='name'
            list={athletes}
            headerWidthPx={220}
            placeholder='Select an Athlete'
            readOnly
            selectItemFunction={setAthlete}
          />
        </MenuOptionsContainer>
        {/* Athlete Chart */}
        <OverviewChart isAthlete />
      </DashboardContainer>
    </>
  );
};

ViewOnlyOverview.propTypes = {
  token: PropTypes.string.isRequired,
};

export default ViewOnlyOverview;
